<template>
  <div class="login">
    <div class="login__body">
      <div class="login__logo">
        <logo />
      </div>
      <div class="title-container">
        Происходит вход<span class="loading loading--active">.</span>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Icons/LogoCampaign.vue";
import Eye from "@/manzana_library/components/Icons/Eye";
import Login from "@/manzana_library/components/Icons/Login";
import Password from "@/manzana_library/components/Icons/Password";
import Button from "@/manzana_library/components/Elements/Button";

import VueRecaptcha from "vue-recaptcha";
import AuthenticationService from "@/services/AuthenticationService";
import router from "@/router";
import store from "@/store";

export default {
  name: "RedirectPage",

  components: {
    Logo,
    Eye,
    Login,
    Password,
    Button,
    VueRecaptcha,
  },

  data() {
    return {
      hasRecaptcha: true,
      showAuthLogin: true,
      recaptchaHost: "google.com",
      loading: false,
      login: {
        company: "",
        user: "",
        password: "",
      },
      showPassword: false,
      error: "",
      sitekey: "6Levw7QZAAAAABF-hlFbye5ZaoOT-knXu8CkAilL",
    };
  },

  created() {
    let state = this.$route.query.state;
    let code = this.$route.query.code;
    let tenant = this.$route.params.tenant;
    this.sendState(state, code, tenant);
  },

  methods: {
    async sendState(state, code, company) {
      try {
        if (state && code) {
          const urlInfo = {
            RedirectURL: `${window.location.protocol}//${window.location.host}/authorization/${company}`,
          };
          const getAuthType = await AuthenticationService.sendKeycloakData(
            state,
            code,
            company,
            urlInfo
          )
          this.$store.commit("SET_USER_INFO", {
            login: getAuthType.data.Login,
            authTokenType: 'Keycloak',
            company,
            ...getAuthType.data,
          });
          if (this.$route.query.redirect)
            this.$router.push({ path: this.$route.query.redirect });
          else this.$router.push({ name: "home" });
        }
      } catch (err) {
        console.warn(err)
        if (err.message === 'Request failed with status code 401') {
          await store.dispatch("REMOVE_TOKEN");
          this.$router.push({ name: "login" });
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$eye-width: 40px;

.loading {
  $duration: 1.5s;

  &:not(.loading--active) {
    display: none;
  }

  &--active {
    &::before,
    &::after {
      content: "";
      animation: dot-loading $duration infinite alternate;
    }
    &::before {
      animation-delay: -$duration;
    }
  }
}

@keyframes dot-loading {
  0%  { content:  "" }
  50% { content: "." }
}

.title-container {
  width: 310px;
  font-size: 32px;
  font-weight: 400;
  line-height: 46px;
}

.login {
  display: flex;
  justify-content: center;
  align-self: center;
  background: $color_gray_3;
  @include size(100%, 100vh);

  &__body {
    background: $color_white;
    align-self: center;
    padding: ($gutter / 2) ($gutter / 1.25) $gutter;
    border-radius: $border-radius_base;
  }

  &__control {
    width: 412px;
    padding-left: $eye-width !important;

    &--password {
      width: calc(412px - #{$eye-width});
      padding-left: $eye-width !important;
      margin-right: $eye-width !important;
    }
  }

  &__form-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: $gutter / 2;

    &-label {
      margin-bottom: $gutter / 4;
    }
  }

  &__eye {
    position: absolute;
    bottom: 13px;
    right: 7px;
    fill: $color_primary;
    cursor: pointer;
    @include size(20px, 14px);

    &--hide {
      fill: $color_active;
    }
  }

  &__logo {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    svg {
      height: 50px;
      width: 100%;
      margin: 0;
      padding: 15px 0 10px;
    }
  }

  &__error {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    color: $color_error;
    text-align: center;
  }

  &__controls {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__button {
    margin: 0;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  &__link {
    font-size: 16px;
    color: $color_primary;
    text-decoration: underline;
  }

  .icon--login,
  .icon--password {
    position: absolute;
    left: 10px;
  }

  .icon--login {
    bottom: 10px;
  }

  .icon--password {
    bottom: 8px;
  }
}
</style>
